const liveViewTutorial = {
  module: 'liveview',
  moduleName: 'Live View',
  steps: [
    {
      target: '.dashboard-stat-row',
      position: 'bottom',
      title: 'Quick Stats',
      description: 'See camera count, door readers, and device health at a glance.',
    },
    {
      target: '.dashboard-customize-btn',
      position: 'bottom',
      title: 'Customize',
      description: 'Drag, resize, and add widgets to build your perfect dashboard.',
    },
    {
      target: '.dashboard-widget',
      position: 'top',
      title: 'Widgets',
      description: "Each card shows live data from your security systems. Click 'View all' to dive deeper.",
    },
  ],
};

export default liveViewTutorial;
